import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { LeadStatus } from '../api/models';
import { State } from '../store/interfaces';
import {
  loadStatusErrorAction,
  loadStatusRequestAction,
  loadStatusSuccessAction,
} from '../store/reducers/leadStatus';
import { StatusCodes } from 'http-status-codes';
import { LeadStatusService } from '../api';

export const useLeadStatus = (leadStatusService: LeadStatusService) => {
  const intent = useSelector((state: State) => state.leadStatus);

  const [updating, setUpdating] = useState<boolean>(false);
  const [updateError, setUpdateError] = useState<string | undefined>();
  const dispatch = useDispatch();

  const loadLeadStatus = async () => {
    if (intent.isLoading || intent.isLoaded) {
      return;
    }
    dispatch(loadStatusRequestAction());
    try {
      const response = await leadStatusService.loadAllLeadStatus();

      return dispatch(loadStatusSuccessAction(response));
    } catch (error) {
      return dispatch(loadStatusErrorAction());
    }
  };

  const updateLeadStatus = async (
    data: LeadStatus,
    id?: string,
    onSuccess?: () => void
  ) => {
    setUpdateError(undefined);
    setUpdating(true);
    try {
      const response = await leadStatusService.updateLeadStatus(data, id);
      if (response.status === StatusCodes.OK) {
        if (onSuccess) onSuccess();
      } else {
        setUpdateError('Unable to update details');
      }
    } catch (error) {
      setUpdateError('Unable to update details');
    }
    setUpdating(false);
  };

  return {
    loadLeadStatus,
    updateLeadStatus,
    updating,
    updateError,
  };
};
